import type { WebsocketAwarenessState } from '../../hooks/useWebsocket/websocket';
import type { UserLocalStorage } from '../../types/localStorage';

import { twMerge } from 'tailwind-merge';
import useLocalStorageState from 'use-local-storage-state';

import { getUniqueEditors } from '../../form-hooks/lib/helpers';
import { getTestProps } from '../../lib/helpers';

import Avatar from '../Avatar/Avatar';

const CountIndicator = ({
  count,
  className,
}: {
  count: number;
  className: string;
}) => (
  <span
    className={twMerge(
      'flex text-base rounded-full items-center justify-center',
      'border border-slate-300 w-8 h-8 dark:text-slate-200',
      className,
    )}
  >
    +{count}
  </span>
);

const FormEditorsIndicator = ({
  editors,
  testId,
}: {
  editors: WebsocketAwarenessState[];
  testId?: string;
}) => {
  const [userLS] = useLocalStorageState<UserLocalStorage>('cms.user');

  const uniqueEditors = getUniqueEditors(editors).filter(
    ({ userId }) => userId !== userLS?.data?.id,
  );

  if (!uniqueEditors.length) return;

  return (
    <div className="flex gap-2">
      {uniqueEditors.map(({ userId, initials }, idx) =>
        idx <= 2 ? (
          <Avatar
            key={userId}
            userInitials={initials}
            additionalClasses={twMerge(
              'h-8 w-8 text-base',
              idx >= 1 && 'hidden xl:flex',
              idx >= 2 && 'hidden',
            )}
            {...getTestProps(testId, `editor-${userId}`, 'testId')}
          />
        ) : undefined,
      )}

      {uniqueEditors.length > 1 && (
        <CountIndicator
          count={uniqueEditors.length - 1}
          className="xl:hidden"
        />
      )}
      {uniqueEditors.length > 3 && (
        <CountIndicator
          count={uniqueEditors.length - 3}
          className="hidden xl:flex"
        />
      )}
    </div>
  );
};

export default FormEditorsIndicator;
